import { HttpErrorResponse } from '@angular/common/http';

export async function rethrowWithParsedBody(cause: unknown): Promise<never> {
  if (!(cause instanceof HttpErrorResponse) || !(cause.error instanceof Blob)) {
    throw cause;
  }

  let error: unknown = null;
  try {
    error = JSON.parse(await cause.error.text());
  } catch {
    error = null;
  }
  throw new HttpErrorResponse({
    error,
    headers: cause.headers,
    status: cause.status,
    statusText: cause.statusText,
    url: cause.url ?? undefined,
  });
}
